import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <h6>© 2022 Lakshan Rukantha. All rights reserved.</h6>
    </footer>
  );
};

export default Footer;
